
import React from 'react';
import { createTheme,ThemeProvider } from '@mui/material/styles';
 const myCustomTheme = createTheme({
    palette: {
        primary: {
          main: 'rgb(0, 153, 0)', //hay que definir los colores
          dark: '#1F5779',
        },
        secondary: {
          main: 'rgb(0, 43, 92)',
          dark: '#3DEAA1'
        },
        success:{
          dark: '#4BB543',
          main:"rgb(8 166 96 / 92%)"
        },
        warning:{
          main: '#FFCC00'
        },
        error:{
          main: '#E31B23'
        }
      }    
 })

 export const CustomThemeProvider = ({children})=>{
     return <ThemeProvider theme= {myCustomTheme}>
         {children}
     </ThemeProvider>
 }

